
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { SortButtons } from "components/common/SortButtons";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { PAGELENGTH } from "components/common/ListLayout";
import AddExtensions from "components/extensions/AddExtensions";
import { extensionSelector } from "slices/extensionsSlice";
import { fetchExtensions } from "slices/extensionsSlice";
import { removeMultipleExtensions } from "slices/extensionsSlice";
import { removeExtensions } from "slices/extensionsSlice";
import { Controller, useForm } from "react-hook-form";
import { addBulkExtensions } from "slices/extensionsSlice";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();

function ExtensionsList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { extension: extensions, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(extensionSelector);
  const { control, handleSubmit } = useForm({
    defaultValues: {
      starting_from: '',
      quantity: '',
    }
  });

  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}
  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });


  React.useEffect(() => {
    dispatch(fetchExtensions())
  }, [])

  const handleAddExtensionsPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchExtensions())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = React.useCallback(() => {

    if (!selectAll && selectedItems?.length === 1) {
      dispatch(removeExtensions(selectedItems[0], submitCallback))
    }
    else {
      dispatch(removeMultipleExtensions({ ids: selectedItems }, submitCallback))
    }

  }, [selectedItems, selectAll])


  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(extensions && extensions?.map((extensions) => extensions.id.toString()))
  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchExtensions(page));
  }, [])

  const handleClose = () => {
    setAddForm({ show: false })
  };

  const handleSelect = (value) => {
    setSelectedValue(value)
  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchExtensions(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Extension') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th className="col-1">
          <TableHeaderItem
            title="Extensions"
            sortBy="extensions_code"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">

          <TableHeaderItem
            title="Password"
            sortBy="password"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="Agent Name"
            sortBy="agent_name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Edit Extension') &&
          <th className="col-1">Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, extensions]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      extensions && extensions?.map((extension, index) => (
        <ExtensionsItems extension={extension} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddExtensionsPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [extensions, selectedItems, current_page]);

  //#endregion

  function handleBuldAdd(data) {

    dispatch(addBulkExtensions(data, submitCallback));
  }


  return (
    <>
      {checkPermission('Bulk Extensions') &&
        <div className="content for_child">
          <div className="row_main_head"><h2 className="main_heading undefined">Bulk Extensions</h2></div>
          <div className="card_table">
            <form className="form_bulk">
              <div className="row-primary">
                <h2>Starting Extension*</h2>
                <Controller
                  name="starting_from"
                  control={control}
                  render={({ field }) =>
                    <input className="input-in type_inp" type="number" name='starting_from' placeholder='Starting Extension' required {...field} />
                  }
                />
              </div>
              <div className="row-primary">
                <h2>Quantity*</h2>
                <Controller
                  name="quantity"
                  control={control}
                  render={({ field }) =>
                    <input className="input-in type_inp" type="number" name='quantity' placeholder='Quantity' required {...field} />
                  }
                />
              </div>
              <button className="main_button" type="button" onClick={handleSubmit(handleBuldAdd)}>Add</button>
            </form>
          </div>
        </div>
      }

      <ListLayout
        heading="Extensions"
        time={false}
        title=""
        buttonTitle="Add Extensions"
        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        totalPages={totalPages}
        fetchList={fetchExtensions}
        addButtonDisabled={!checkPermission('Add Extension')}
        selectedItems={selectedItems}
        handleRemoveItems={handleRemoveItems}
        renderAddForm={(callback) => <AddExtensions item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} />}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddExtensionsPopUp}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        loader={loader}
        searchPlaceholder="Search Extensions ..."
        noOfItems={total}
      >

        {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
      </ListLayout>

    </>
  )

}


const ExtensionsItems = ({
  extension, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  const maskPassword = (password) => {
    return password ? ' • '.repeat(password.length) : '';
  };

  return (
    <tr>
      <td>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Extension') &&
          <label className="custom-checkbox checkbox">
            <input type="checkbox" name="select-all" data-value={extension?.id} checked={selectedItems.includes(extension?.id.toString())} onChange={handleChange} />
            <span className="checkmark"></span>
          </label>
          }
        </div>
      </td>
      <td>
        {extension?.extension}
      </td>
      <td className="lead">
        {maskPassword(extension?.password)}
      </td>
      <td>
        {extension?.status}
      </td>
      <td>
        {extension?.user?.name}
      </td>
      {checkPermission('Edit Extension') &&
      <td>
        <div className="row_check">
          <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...extension })}>Edit</button>
        </div>
      </td>
      }
    </tr>
  )
}


export default ExtensionsList;
